import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { withRFSToken } from '../../../Services/axios.js';
import { applyOffsetToDateTime , CallApi, CommonModal, jqxCookieCall } from '../../../Components/common/CommonFunctions.js'
import Select from 'react-select';
import { toast } from 'react-toastify'; 
import edit from "../../../assets/images/edit.png";  
import trash from "../../../assets/images/trash.png";  
import ConfModal from '../../../Components/common/ConfModal.js';
import Reset from "../../../assets/images/superadmin/reset.png";

const DeviceSettings = () => {
    const isMounted = useRef(false);
    const [modalShow , setModalShow] = useState(false)
    const [formData, setFormData] = useState(false)
    const gridRefs = useRef(null);
    const [location, setLocation] = useState();
    const [allData, setAlldata] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [accessRow, setAccessRow] = useState(null);
    const [pendingAccess, setPendingAccess] = useState('');
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const [linkModal, setLinkModal] = useState(false);
    const [dvLink, setDvLink] = useState('');
    const inputRef = useRef(null);
    let checkUlds = [];
    const SBack = localStorage.getItem('SettingsBack');

    useEffect(() => {
        if (isMounted.current) return;
         loadGrid();
        isMounted.current = true;
    }, []);

    const handleActiveInvoice = (id) => {
        if(gridSelect.length != 1){
            toast.error("Select exactly 1 device to change status");
            return;
        }
         CallApi({
              endPoint: `vehicle-management/update-organization-system/${id}`,
              method: "GET",
              onSuccess: (data) => {
                 window.$(gridRefs.current).jqxGrid("clearselection");
                 window.$(gridRefs.current).jqxGrid("updatebounddata");
                 setGridSelect([])              },
              onError: (msg) => toast.error(msg)
              });
    };
    const handleRemoveConfirmation = () => {
        if(gridSelect.length == 0) {toast.error("Select Devices to Remove"); return;}
        const handleRemoveDevice = () =>{
             CallApi({
              endPoint: 'vehicle-management/delete-org-system',
              payload: {ids : gridSelect.map(item => item.id)},
              onSuccess: (data) => {
                 if (data.data.response_code === 200) {
                    toast.success(data.data.response_msg);
                    window.$(gridRefs.current).jqxGrid("clearselection");
                    window.$(gridRefs.current).jqxGrid("updatebounddata");
                    setGridSelect([]);
                } else {
                    toast.error(data.data.response_msg);
                }
                },
              onError: (msg) => toast.error(msg)
              });
        }
         setConfData({
            header: `Remove ${gridSelect.length == 1 ? 'Device' : 'Devices'}`,
            subHeader: `Are you sure you want to remove the ${gridSelect.length == 1 ? 'device' : 'devices'} : ${gridSelect.map(item => item.device_name).join(', ')} ?`,
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: handleRemoveDevice,
        });
        setModalConf(true);
    }
    const handleAccessSave = () => {
        if (!accessRow || !pendingAccess) {
            toast.error("Please select an access type.");
            return;
        }

        CallApi({
            endPoint: 'vehicle-management/update-module-access',
            payload: {
                id: accessRow.id,
                module_access: pendingAccess
            },
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    toast.success("Access updated successfully");
                    setShowAccessModal(false);
                    setAccessRow(null);
                    setPendingAccess('');
                    if (gridRefs.current) {
                        window.$(gridRefs.current).jqxGrid("updatebounddata");
                    }
                } else {
                    toast.error(data.data.response_msg || "Failed to update access");
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const handleAccessCancel = () => {
        setShowAccessModal(false);
        setAccessRow(null);
        setPendingAccess('');
    };

    const openModal = async () => {
        try {
            const res = await withRFSToken.post('vehicle-management/generate-link', { type: 'Driver' });
            const innerData = res?.data?.response_data;
            if (res.data.response_code === 200) {
                setDvLink(innerData?.passcode || '');
                setLinkModal(true);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error fetching passcode:', error);
            toast.error('Failed to load passcode');
        }
    };

    const openUserModal = () => {
        setFormData({});
        setModalShow(true);
    }
    const handleUserModalClose = () => {
        setModalShow(false);
    }
    const handleUserModalSave = () => {
        if (!formData?.device_name?.trim())
        return toast.error("Device Name is required");
        if (!formData?.module_access)
        return toast.error("Access Type is required");        

        CallApi({
            endPoint: 'vehicle-management/save-device-key',
            payload : formData,
             onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    toast.success(res?.data?.response_msg || (formData?.id ? "Device updated successfully" : "Device saved successfully"));
                    if (gridRefs.current) {
                        window.$(gridRefs.current).jqxGrid("updatebounddata");
                    }
                    setModalShow(false);
                }
                else {
                    toast.error(res.data.response_msg || "Failed to update Device");
                }
            },
            onError: (msg) => toast.error(msg)
        })
    }

    const handleResetPassword = (id) => {
         CallApi({
            endPoint: `vehicle-management/re-generate-system-key/${id}`,
            method: 'patch',
             onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    toast.success(res.data.response_msg);
                    if (gridRefs.current) {
                        window.$(gridRefs.current).jqxGrid("updatebounddata");
                    }
                }
                else {
                    toast.error(res.data.response_msg || "Failed to update user");
                }
            },
            onError: (msg) => toast.error(msg)
        })
    }
    
    const closeConfirm = () => {
        setLinkModal(false);
    };

    const handleCopy = () => {
        if (inputRef.current) {
            inputRef.current.select();
            inputRef.current.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(inputRef.current.value);
        }
    };

    const regenerateLink = async () => {
        try {
            const res = await withRFSToken.post('vehicle-management/generate-org-passcode', { type: 'Driver' });
            if (res.data.response_code === 200) {
                const innerData = res?.data?.response_data;
                setDvLink(innerData?.passcode || '');
                toast.success('Passcode regenerated successfully');
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error regenerating passcode:', error);
            toast.error('Failed to regenerate passcode');
        }
    };

    const handleRegenerateConfirm = () => {
        setConfData({
            header: "Regenerate Passcode",
            subHeader: "Are you sure you want to regenerate the passcode?",
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: regenerateLink,
        });
        setModalConf(true);
    };

    const confModalClose = () => {
        setModalConf(false);
    };

    const loadGrid = () => {
        // const token = 'Bearer ' + localStorage.DVR;
        jqxCookieCall();
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}vehicle-management/get-organization-system-list`,
            root: 'Rows',
            cache: false,
            datafields: [
                { name: 'id', type: 'string' },
                { name: 'system_key', type: 'string' },
                { name: 'device_name', type: 'string' },
                { name: 'created_at', type: 'string' },
                { name: 'module_access', type: 'string' },
                { name: 'status', type: 'string' },
            ],
            // beforeSend: (jqXHR) => {
            //     jqXHR.setRequestHeader('Authorization', token);
            // },
            filter: function (allfilters) {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: function (data) {
                setAlldata(data.response_data);
            }
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
           {
            text: 'Actions',
            cellsrenderer: function () {
                return '<div class="grid_actions"><img src="' + Reset + '" class="row_reset" /><img src="' + edit + '" class="row_edit" /></div>';
            },
            width: '5%', filterable: false,
            },
            // { text: 'Device ID', datafield: 'system_key', width: '18%',},
            { text: 'Device Name', datafield: 'device_name', width: '18%',},
            { text: 'Passcode', datafield: 'system_key', width: '18%',},
            { text: 'Created At', datafield: 'created_at', width: '18%', filtertype: 'range',
                cellsrenderer: function (row, columnfield, value) {
                    const formatted = applyOffsetToDateTime(value , "L");
                    return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
                }
            },
            { text: 'Access', datafield: 'module_access', width: '18%', filtertype: 'checkedlist',
                filteritems: [
                    { label: 'Driver', value: 'D' },
                    { label: 'Visitor', value: 'V' },
                    { label: 'Both', value: 'B' },
                ],
                 cellsrenderer: function (row, columnfield, value) {
                   const access = value === 'B' ? 'Both' : value === 'D' ? 'Driver' : value === 'V' ? 'Visitor' : '';
                    return `<div class="jqx-grid-cell-left-align access" style="margin-top: 13.5px; cursor: pointer;">${access}</div>`;
                }               
            },
            { text: 'Status', datafield: 'status', width: '18%', filtertype: 'checkedlist',
                filteritems: [
                    { label: 'Active', value: '1' },
                    { label: 'Inactivate', value: '0' },
                ],
                cellsrenderer: function (row, columnfield, value) {
                    const status = value == 1 ? 'Active' : 'Inactive';
                    const color = value ? 'green' : 'red';
                    return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px; color: ${color} !important;">${status}</div>`;
                }              
            },
        ];
        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pageable: true,
            selectionmode: 'checkbox',
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
            ready: function () {
                // const rows = window.$(gridRefs.current).jqxGrid('getrows');
                // rows.forEach((row, idx) => {
                //     if (row.status === '1' || row.status === 1) {
                //         window.$(gridRefs.current).jqxGrid('selectrow', idx);
                //     }
                // });
            }
        };

         window.$(gridRefs.current).on("celldoubleclick", function (event) {
            const args = event.args;
            const datafield = args.datafield;
            if (['system_key'].includes(datafield)) {
                  const cellValue = args.value;
                 if (cellValue !== null && cellValue !== undefined && String(cellValue).trim() !== '') {
                    navigator.clipboard.writeText(String(cellValue))
                      .then(() => {
                        toast.success("Copied to clipboard: " + cellValue);
                      })
                      .catch(err => {
                        // optional error handling
                        // console.error("Failed to copy:", err);
                      });
                  }
              }
        });
 
        window.$(gridRefs.current).jqxGrid(gridOptions);
        window.$(gridRefs.current).off("click", ".access");
        window.$(gridRefs.current).on("click", ".access", function (e) {
            e.stopPropagation();

            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndexAttr = window.$(rowDiv).attr("row-id");

            if (rowIndexAttr !== undefined) {
                const pagingInfo = window.$(gridRefs.current).jqxGrid("getpaginginformation");
                const pageIndex = pagingInfo.pagenum;
                const pageSize = pagingInfo.pagesize;
                const globalIndex = parseInt(rowIndexAttr, 10) + pageIndex * pageSize;
                const rowData = window.$(gridRefs.current).jqxGrid("getrowdata", globalIndex);

                if (rowData && rowData.id) {
                    setAccessRow(rowData);
                    setPendingAccess(rowData.module_access || '');
                    setShowAccessModal(true);
                }
            }
        });
        window.$(gridRefs.current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
        setFormData({ id: rowData.id, device_name: rowData.device_name, module_access: rowData.module_access, status: rowData.status});
        setModalShow(true);
        });
        window.$(gridRefs.current).on('click', '.row_reset', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
        setConfData({
            header: `Reset Passcode`,
            subHeader: `Are you sure you want to reset the passcode for device: ${rowData.device_name}?`,
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: () => handleResetPassword(rowData?.id),
        });
        setModalConf(true);
        });
        window.$(gridRefs.current).on('rowselect', (event) => {
            if (event.args.row) {
                const selectedRow = event.args.row;
                const uldNumber = selectedRow.id;
                const selectedRowId = selectedRow.uid;
                if (!checkUlds.includes(uldNumber)) {
                    checkUlds.push(uldNumber);
                }
                setGridSelect(prevGridSelect => {
                    if (!prevGridSelect.some(row => row.id === uldNumber)) {
                        return [...prevGridSelect, selectedRow];
                    }
                    return prevGridSelect;
                });
            } else {
                if (event.args.rowindex.length > 0) {
                    const allIds = window.$(gridRefs.current).jqxGrid('getrows');
                    setGridSelect(allIds);
                } else {
                    setGridSelect([]);
                }
            }
        });
        window.$(gridRefs.current).on('rowunselect', (event) => {
            if (event.args.row) {
                const unselectedRowId = event.args.row.id;
                setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                if (!checkUlds.includes(unselectedRowId)) {
                    checkUlds.push(unselectedRowId);
                } else {
                    checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                }
            }
        });
    };
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    return (
        <>
        {console.log("modal conf" , modalConf)}
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confModalClose}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                    <div className='category_invoice_title'>
                        <h4>Device Settings</h4>
                        <p>Set your notification preferences for when you are in or away from the dashboard</p>
                    </div>
                    <div className='d-flex justify-content-start mb-3'>
                        {/* <Button className="addtruck ms-2 me-2" variant="primary" onClick={openModal}>
                            <span>Get Passcode</span>
                        </Button> */}
                        <Button className="addtruck ms-2 me-2" variant="primary" onClick={openUserModal}>
                            <span><FontAwesomeIcon icon={faPlus} /> Create Device</span>
                        </Button>
                        <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleActiveInvoice(gridSelect[0]?.id)}>Activate Device</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleActiveInvoice(gridSelect[0]?.id)}>Deactivate Device</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleRemoveConfirmation()}>Remove Device</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className='trashdonload'>
                        <div ref={gridRefs} className='setting_bookinggrid' ></div>
                    </div>
                </div>
            </div>

            <Modal className="addfrom change_type" show={showAccessModal} onHide={handleAccessCancel} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Update Module Access</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Select access type for this device.</p>
                    <Form>
                        <Form.Check
                            type="radio"
                            id="access-driver"
                            name="moduleAccess"
                            label="Driver"
                            value="D"
                            checked={pendingAccess === 'D'}
                            onChange={(e) => setPendingAccess(e.target.value)}
                        />
                        <Form.Check
                            type="radio"
                            id="access-visitor"
                            name="moduleAccess"
                            label="Visitor"
                            value="V"
                            checked={pendingAccess === 'V'}
                            onChange={(e) => setPendingAccess(e.target.value)}
                        />
                        <Form.Check
                            type="radio"
                            id="access-both"
                            name="moduleAccess"
                            label="Both"
                            value="B"
                            checked={pendingAccess === 'B'}
                            onChange={(e) => setPendingAccess(e.target.value)}
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={handleAccessCancel}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleAccessSave}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={linkModal} onHide={closeConfirm} className="addfrom change_type" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <h3>Get Passcode</h3>
                    {dvLink && (
                        <>
                            {/* <Form.Label>Passcode</Form.Label> */}
                            <p className=" mt-2">
                                Regenerating this passcode will immediately log out any device currently connected using the old passcode.
                            </p>
                            <div className='d-flex'>
                                <Form.Control
                                    type="text"
                                    ref={inputRef}
                                    name="link"
                                    value={dvLink}
                                    readOnly
                                />
                                <Button onClick={handleCopy}> Copy </Button>
                            </div>  
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={closeConfirm}> Cancel</Button>
                        <Button variant="primary" onClick={handleRegenerateConfirm}>
                            {dvLink ? "Regenerate" : "Generate"}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <CommonModal
                show={modalShow}
                onHide={handleUserModalClose}
                title={formData?.id ? "Update Device" : "Create Device"}
                className='addfrom'
                footer={
                    <div className='d-flex w-50 mx-auto are_bottom'>
                    <Button variant="secondary" onClick={handleUserModalClose}>
                        Discard
                    </Button>
                    <Button variant="primary" onClick={handleUserModalSave}>
                        Save
                    </Button>
                </div>
                }>
                <>
                    <Form.Label>Device Name <span>*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="device_name"
                        value={formData?.device_name || ""}
                        onChange={handleInputChange}
                    />                        
                    <Form.Label className='mt-2'>Access Type <span>*</span></Form.Label>
                        <Form>
                            <Form.Check
                                type="radio"
                                id="access-driver"
                                name="module_access"
                                label="Driver"
                                value="D"
                                checked={formData?.module_access === "D"}
                                onChange={handleInputChange}
                            />
                            <Form.Check
                                type="radio"
                                id="access-visitor"
                                name="module_access"
                                label="Visitor"
                                value="V"
                                checked={formData?.module_access === "V"}
                                onChange={handleInputChange}
                            />
                            <Form.Check
                                type="radio"
                                id="access-both"
                                name="module_access"
                                label="Both"
                                value="B"
                                checked={formData?.module_access === "B"}
                                onChange={handleInputChange}
                            />
                        </Form>
                        {/* <Form.Label>Status <span>*</span></Form.Label>
                         <Form>
                            <Form.Check
                                type="radio"
                                id="status-active"
                                name="status"
                                label="Active"
                                value="1"
                                checked={formData?.status == 1}
                                onChange={handleInputChange}
                            />
                            <Form.Check
                                type="radio"
                                id="status-ianctive"
                                name="status"
                                label="Inactive"
                                value="0"
                                checked={formData?.status == 0}
                                onChange={handleInputChange}
                            />
                         </Form> */}
                </>                
            </CommonModal>
        </>
    )
}

export default DeviceSettings
